import { createRoot } from 'react-dom/client';
import { applyMiddleware, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { Provider } from 'react-redux';

import { getInitialState, officeApp } from 'reducers';
import properties from 'resources/constants/properties.json';

import App from './App';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const title = "NorthGravity Add-in";
const FUNCTIONS_NAMESPACE = properties.functionsNamespace

let rootElement, root

if (properties.version === "LOCALHOST" && module.hot) {
  module.hot.accept();
} else {
  rootElement = document.getElementById('container');
  root = createRoot(rootElement)
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: "online",
      retry: 0,
      retryDelay: 3000,
      staleTime: 3000
    },
    mutations: {
      networkMode: "online"
    }
  }
})

const renderApp = () =>
  root.render(
    <Provider store={window["ngStore" + FUNCTIONS_NAMESPACE]}>
      <QueryClientProvider client={queryClient}>
        <App title={title}/>
      </QueryClientProvider>
    </Provider>
  )

const onReady = () => {
  if(!window["ngStore" + FUNCTIONS_NAMESPACE]) {
    window["ngStore" + FUNCTIONS_NAMESPACE] = createStore((state, action) => officeApp(state, action), getInitialState(), applyMiddleware(thunkMiddleware))
  }
  renderApp();  
}

if(properties.version === "LOCALHOST") {
  document.addEventListener('DOMContentLoaded', () => {
    if (!root) {
      rootElement = document.getElementById('container');
      root = createRoot(rootElement)
    }
    onReady()
  });
} else {
  if(Office.addin) {
    Office.addin.setStartupBehavior?.(Office.StartupBehavior.load)
    onReady()
  } else {
    Office.onReady(() => {
      Office.addin?.setStartupBehavior?.(Office.StartupBehavior.load)
      onReady()
    })
  }
}